export function AutomexLogo({ className = "", variant = "dark" }) {
  const src = variant === "light"
    ? "/logos/automex-group-india-light.png"
    : "/logos/automex-group-india.png";

  return (
    <img
      src={src}
      alt="AutoMex Group India"
      width="1200"
      height="261"
      className={`h-12 md:h-14 w-auto select-none ${className}`}
      draggable="false"
    />
  );
}
